/**
 * gift-options.js — PDP cadeau-functie voor de KrownThemes "Local" theme.
 *
 * Toont onder de buy-buttons:
 *   1. checkbox "Als cadeau laten inpakken"  -> voegt het inpak-product (€1,99) toe
 *   2. checkbox "Voeg een persoonlijk kaartje toe" (verschijnt na 1) -> voegt het kaartje-product (€1,99) toe
 *   3. berichtveld (verschijnt na 2) -> komt als line item property op de kaartje-regel EN in de order note
 *
 * Werkwijze: bij "toevoegen aan winkelmand" voegen we eerst de add-ons toe
 * (gededupliceerd, max 1x per order, qty altijd 1) en laten daarna de native
 * theme-handler het hoofdproduct toevoegen + de cart-drawer verversen.
 */
(function () {
  'use strict';
  if (window.__giftOptionsInit) return;
  window.__giftOptionsInit = true;

  // Styles één keer injecteren (geen inline <style> in het blok -> overleeft section hot-reload).
  (function injectStyles() {
    if (document.getElementById('gift-options-styles')) return;
    var css = ''
      + '.gift-options{margin:1.25em 0;display:flex;flex-direction:column;gap:.85em}'
      + '.gift-options__row{display:flex;align-items:center;gap:.7em;line-height:1.3}'
      + '.gift-options__row label{margin:0;cursor:pointer}'
      + '.gift-options__message{margin-top:.15em}'
      + '.gift-options__message textarea{width:100%;min-height:84px;padding:.7em .8em;font:inherit;color:inherit;'
      + 'background:var(--color-background-main,transparent);border:1px solid var(--color-border,rgba(0,0,0,.18));'
      + 'border-radius:var(--theme-input-border-radius,6px);resize:vertical}'
      + '.gift-options__message textarea:focus{outline:2px solid var(--color-accent-main);outline-offset:1px}'
      + '.gift-options__error{display:block;margin-top:.4em;color:#c0392b;font-size:.85em}'
      + '.gift-options [hidden]{display:none!important}';
    var style = document.createElement('style');
    style.id = 'gift-options-styles';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  })();

  // Vind het cadeau-blok dat bij dit formulier hoort: loop omhoog vanaf de form
  // tot een voorouder die zowel de form als een [data-gift-options] bevat.
  function findGiftRoot(form) {
    var node = form;
    while (node && node.nodeType === 1) {
      if (node.querySelector) {
        var hit = node.querySelector('[data-gift-options]');
        if (hit) return hit;
      }
      node = node.parentElement;
    }
    return document.querySelector('[data-gift-options]');
  }

  function routes() {
    return (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
  }
  function addUrl()    { return (routes().cart_add_url    || '/cart/add') + '.js'; }
  function changeUrl() { return (routes().cart_change_url || '/cart/change'); }
  function updateUrl() { return (routes().cart_update_url || '/cart/update'); }
  function cartUrl()   { return (routes().cart_url        || '/cart') + '.js'; }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(cartUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- Progressive disclosure ---------- */
  function wire(root) {
    if (root.__giftWired) return;
    root.__giftWired = true;

    var giftCb  = root.querySelector('[data-gift-wrap]');
    var cardCb  = root.querySelector('[data-gift-card]');
    var cardRow = root.querySelector('[data-gift-card-row]');
    var msgWrap = root.querySelector('[data-gift-message-wrap]');
    var errEl   = root.querySelector('[data-gift-error]');
    if (!giftCb) return;

    function sync() {
      var giftOn = giftCb.checked;
      if (cardRow) cardRow.hidden = !giftOn;
      if (!giftOn && cardCb) cardCb.checked = false;
      var cardOn = giftOn && cardCb && cardCb.checked;
      if (msgWrap) msgWrap.hidden = !cardOn;
      if (errEl) errEl.hidden = true;
    }
    giftCb.addEventListener('change', sync);
    if (cardCb) cardCb.addEventListener('change', sync);
    sync();
  }

  function wireAll() {
    document.querySelectorAll('[data-gift-options]').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  // Theme editor / quick-view kan de sectie opnieuw renderen.
  document.addEventListener('shopify:section:load', wireAll);

  /* ---------- Add-to-cart interceptie (klik op ATC, capture-fase, vóór de theme-handler) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-js-product-add-to-cart]');
    if (!btn) return;

    var form = btn.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var root = findGiftRoot(form);
    if (!root) return; // geen cadeau-blok op dit product

    // Tweede doorgang: wij gaven het stokje terug aan de theme -> niet opnieuw onderscheppen.
    if (btn.__giftDone) { btn.__giftDone = false; return; }

    var giftCb = root.querySelector('[data-gift-wrap]');
    var cardCb = root.querySelector('[data-gift-card]');
    var wantGift = !!(giftCb && giftCb.checked);
    var wantCard = !!(cardCb && cardCb.checked && giftCb && giftCb.checked);
    if (!wantGift && !wantCard) return; // niets extra's -> native flow

    var GIFT_ID = root.getAttribute('data-gift-variant');
    var CARD_ID = root.getAttribute('data-card-variant');
    var PROP    = root.getAttribute('data-card-prop') || 'Bericht op kaartje';
    var required = root.getAttribute('data-message-required') === 'true';
    var msgEl = root.querySelector('[data-gift-message]');
    var message = msgEl ? msgEl.value.trim() : '';

    // Validatie: kaartje gekozen maar leeg bericht.
    if (wantCard && required && !message) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var errEl = root.querySelector('[data-gift-error]');
      if (errEl) errEl.hidden = false;
      if (msgEl) msgEl.focus();
      return;
    }

    if (wantCard && !CARD_ID) wantCard = false;
    if (wantGift && !GIFT_ID) wantGift = false;
    if (!wantGift && !wantCard) return;

    // Wij nemen het over: blokkeer deze klik, voeg eerst de add-ons toe,
    // en klik daarna nogmaals zodat de native handler het hoofdproduct toevoegt
    // + de cart-drawer ververst (incl. onze add-ons die er dan al in zitten).
    e.preventDefault();
    e.stopImmediatePropagation();

    btn.classList.add('working');

    syncAddons({
      GIFT_ID: GIFT_ID, CARD_ID: CARD_ID, PROP: PROP,
      message: message, wantGift: wantGift, wantCard: wantCard
    })
      .catch(function (err) { console.error('[gift-options]', err); })
      .then(function () {
        btn.__giftDone = true;
        btn.classList.remove('working');
        btn.click();
      });
  }, true);

  function lineFor(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(id)) return items[i];
    }
    return null;
  }

  function syncAddons(o) {
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var giftLine = lineFor(items, o.GIFT_ID);
      var cardLine = lineFor(items, o.CARD_ID);
      var chain = Promise.resolve();

      // Inpakken (max 1x, qty 1)
      if (o.wantGift && !giftLine) {
        chain = chain.then(function () { return postJSON(addUrl(), { items: [{ id: Number(o.GIFT_ID), quantity: 1 }] }); });
      } else if (!o.wantGift && giftLine) {
        chain = chain.then(function () { return postJSON(changeUrl(), { id: giftLine.key, quantity: 0 }); });
      }

      // Kaartje (max 1x, qty 1) + bericht als property
      if (o.wantCard) {
        var props = {}; props[o.PROP] = o.message;
        if (!cardLine) {
          chain = chain.then(function () { return postJSON(addUrl(), { items: [{ id: Number(o.CARD_ID), quantity: 1, properties: props }] }); });
        } else {
          chain = chain.then(function () { return postJSON(changeUrl(), { id: cardLine.key, quantity: 1, properties: props }); });
        }
      } else if (!o.wantCard && cardLine) {
        chain = chain.then(function () { return postJSON(changeUrl(), { id: cardLine.key, quantity: 0 }); });
      }

      // Order note voor fulfilment — expliciet wat er moet gebeuren.
      // Markers [CADEAU]…[/CADEAU] zodat we het blok bij wijzigen netjes vervangen
      // i.p.v. opstapelen, en eventuele andere note-inhoud intact laten.
      chain = chain.then(function () {
        var block = buildGiftNote(o.wantGift, o.wantCard, o.message);
        var existing = (cart && cart.note) || '';
        var merged = mergeGiftNote(existing, block);
        if (merged === existing) return null;
        return postJSON(updateUrl(), { note: merged });
      });

      return chain;
    });
  }

  function buildGiftNote(wantGift, wantCard, message) {
    var parts = [];
    if (wantGift) parts.push('inpakken als cadeau');
    if (wantCard) parts.push('kaartje met tekst: "' + (message || '') + '"');
    if (!parts.length) return '';
    return '[CADEAU] ' + parts.join(' + ') + ' [/CADEAU]';
  }

  function mergeGiftNote(existing, block) {
    var stripped = String(existing || '')
      .replace(/\[CADEAU\][\s\S]*?\[\/CADEAU\]\s*/g, '')
      .replace(/--- CADEAU ---[\s\S]*?--- \/CADEAU ---\s*/g, '')
      .replace(/\s+$/, '');
    if (!block) return stripped;
    return stripped ? (stripped + '\n\n' + block) : block;
  }
})();
